export default __webpack_public_path__ + "static/static-asset-Wallet-3baa3f6962dd29b97994357c29a679df.svg";